import type { Destination } from './destinations'

/**
 * Destination data is injected at build time by the prerender
 * (scripts/generate-static.ts) as window.__DESTINATIONS_DATA__. In `vite dev`
 * it is absent and lists render empty, exactly like the blog.
 */
declare global {
  interface Window {
    __DESTINATIONS_DATA__?: {
      posts: Destination[];
    };
  }
}

export async function getDestinations(): Promise<Destination[]> {
  if (typeof window !== 'undefined' && window.__DESTINATIONS_DATA__) {
    return window.__DESTINATIONS_DATA__.posts;
  }
  return [];
}
